import { FInter, FlexBox } from '@brg/ui';
import { FC } from 'react';
import styled from 'styled-components';

export const BCoreLoaderWrapper = styled(FlexBox)`
    width: 100px;
    height: 64px;
    padding-left: 16px;
    place-items: center;

    svg {
        transform: scale(1.1);
    }
`;

type TProps = {
    text: string;
    loading: boolean;
    color?: string;
}

export const ProgressBar: FC<TProps> = ({ text, loading, color }) => {

    return (
        <div>
        {loading && (
            <BCoreLoaderWrapper direction="row" gx={8} className={'loader-wrapper'}>
            <svg width="38" height="38" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg" stroke="#D9D9D9">
                <g fill="none" fillRule="evenodd">
                    <g transform="translate(1 1)" strokeWidth="2">
                        <circle strokeOpacity=".5" cx="18" cy="18" r="18" />
                        <path d="M36 18c0-9.94-8.06-18-18-18">
                            <animateTransform
                                attributeName="transform"
                                type="rotate"
                                from="0 18 18"
                                to="360 18 18"
                                dur="1s"
                                repeatCount="indefinite"
                            />
                        </path>
                    </g>
                </g>
            </svg>
            <FInter.SmallText style={{ fontSize: '13px' }} color={color}>
                {text}
            </FInter.SmallText>
        </BCoreLoaderWrapper>
        )}
        </div>

    )
}
import { FInter, FlexBox } from '@brg/ui';
import { FC } from 'react';
import styled from 'styled-components';

export const BCoreLoaderWrapper = styled(FlexBox)`
    width: 100px;
    height: 64px;
    padding-left: 16px;
    place-items: center;

    svg {
        transform: scale(1.1);
    }
`;

type TProps = {
    text: string;
    loading: boolean;
    color?: string;
}

export const ProgressBar: FC<TProps> = ({ text, loading, color }) => {

    return (
        <div>
        {loading && (
            <BCoreLoaderWrapper direction="row" gx={8} className={'loader-wrapper'}>
            <svg width="38" height="38" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg" stroke="#D9D9D9">
                <g fill="none" fillRule="evenodd">
                    <g transform="translate(1 1)" strokeWidth="2">
                        <circle strokeOpacity=".5" cx="18" cy="18" r="18" />
                        <path d="M36 18c0-9.94-8.06-18-18-18">
                            <animateTransform
                                attributeName="transform"
                                type="rotate"
                                from="0 18 18"
                                to="360 18 18"
                                dur="1s"
                                repeatCount="indefinite"
                            />
                        </path>
                    </g>
                </g>
            </svg>
            <FInter.SmallText style={{ fontSize: '13px' }} color={color}>
                {text}
            </FInter.SmallText>
        </BCoreLoaderWrapper>
        )}
        </div>

    )
}
